export default "/images/92d2b76b4343d7481657c1f6e61a3889.avif";